exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column;padding:0;margin-bottom:3rem}:host .section-header{display:inline-flex;margin-bottom:.5rem;align-items:baseline;color:#0b6ba8;font-family:Open Sans,sans-serif;font-weight:300;font-size:2.2rem}:host .section-header .section-index{margin-right:5px}:host .section-header .section-index:after{content:\".\";margin-right:5px}:host .section-header::ng-deep h2{width:inherit;font-family:Open Sans,sans-serif;font-weight:300;font-size:2.2rem}:host .help-icon{margin-left:20px;font-size:27px;cursor:pointer;color:#005092}:host .section-body,:host .section-help{display:flex;background-color:#fff;width:100%}:host .section-body{flex-direction:column;z-index:5}:host .section-help{z-index:4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/section/section.component.scss
// module id = 749
// module chunks = 0